import { API_CALL_ERROR } from './../../../store/action';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import { WIZARD_PRODUCT_MOVE_COMPLETED, WIZARD_PRODUCT_MOVE_REQUEST, WIZARD_PRODUCT_CREATE_REQUEST, WIZARD_PRODUCT_UPDATE_REQUEST, WIZARD_PRODUCT_CREATED, WIZARD_PRODUCT_UPDATED, WIZARD_PRODUCT_COMPLETED, WIZARD_PRODUCT_SKIP, WIZARD_PRODUCT_SKIP_COMPLETED } from "./wizard.actions";
import * as _ from 'lodash';
import { ApiService } from '../../../api/api.service';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { Router } from '@angular/router';
import { UtilityService } from "../../../common/services/utility/utility.service";

function* createProduct(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    if (action.checkSimilarity && action.checkSimilarity.notification) {
      let results = yield api.product.get({ page: 1, per_page: 1 }, null, action.checkSimilarity.filter).toPromise();
      if (results.items.length > 0) {
        let isCancelled = yield action.checkSimilarity.notification.show().then((res) => {
          if (!res.value) {
            AppInjector.get(NotificationService).show('warning', 'Product creation cancelled', 5000);
            return true;
          }
          return false;
        });
        if (isCancelled) {
          return;
        }
      }
    }
    if (!action.data.id) {
      let result = yield api.product.create(action.data).toPromise();
      // if product location contain default location then move it to default location
      if (result.provider && result.provider.destination_id) {
        yield api.event.create({
          product_sku: result.sku,
          destination_id: result.provider.destination_id
        }).toPromise();
      }
      yield put({ type: WIZARD_PRODUCT_CREATED, data: result });
    } else {
      let result = yield api.product.update(action.data).toPromise();
      // if product location contain default location then move it to default location
      if (result.provider && result.provider.destination_id) {
        yield api.event.create({
          product_sku: result.sku,
          destination_id: result.provider.destination_id
        }).toPromise();
      }
      yield put({ type: WIZARD_PRODUCT_CREATED, data: result });
    }
    // let redirectOptions = {};
    // if (action.redirectOptions) {
    //   redirectOptions = action.redirectOptions;
    // }
    AppInjector.get(UtilityService).nextPageAndKeepReferer([action.redirect]);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCreateProductRequested() {
  yield takeEvery(WIZARD_PRODUCT_CREATE_REQUEST, createProduct);
}

function* moveProduct(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.event.create({
      product_sku: action.data.product_sku,
      destination_id: action.data.destination_id,
      location_id: action.data.location_id
    }).toPromise();
    yield put({ type: WIZARD_PRODUCT_MOVE_COMPLETED, data: result });
    AppInjector.get(NotificationService).show('success', 'Product creation completed', 5000);
    AppInjector.get(UtilityService).redirectAndReset('product');
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchMoveProductRequested() {
  yield takeEvery(WIZARD_PRODUCT_MOVE_REQUEST, moveProduct);
}

function* updateProduct(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.product.update(action.data).toPromise();
    yield put({ type: WIZARD_PRODUCT_UPDATED, data: result });
    if (!action.end) {
      AppInjector.get(UtilityService).nextPageAndKeepReferer([action.redirect]);
    } else {
      AppInjector.get(NotificationService).show('success', 'Product creation completed', 5000);
      yield put({ type: WIZARD_PRODUCT_COMPLETED, data: result });
      router.navigate([action.redirect]);
      AppInjector.get(UtilityService).reset();
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateProductRequested() {
  yield takeEvery(WIZARD_PRODUCT_UPDATE_REQUEST, updateProduct);
}

function* skipProduct(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  AppInjector.get(NotificationService).show('success', 'Product creation skipped', 5000);
  yield put({ type: WIZARD_PRODUCT_SKIP_COMPLETED });
  AppInjector.get(UtilityService).redirectAndReset('product');
}

function* watchSkipProductRequested() {
  yield takeEvery(WIZARD_PRODUCT_SKIP, skipProduct);
}

export default [
  watchCreateProductRequested,
  watchUpdateProductRequested,
  watchSkipProductRequested,
  watchMoveProductRequested
];
